import React from "react";
import Core from "../components/Core";
import Template2001Component from "./Template2001Component";

import screenProvider from "../services/CommonScreenProvider";
import dataProvider from "../services/CommonDataProvider";
import { baseEventHandler } from "../services";

export default class Template2001Container extends React.Component {
    render() {
        return (
            <Core
                screenProvider={screenProvider}
                eventHandler={baseEventHandler}
                dataProvider={dataProvider}
                scrollLimit={2}
                {...this.props}
            >
                {(props) => <Template2001Component {...props} />}
            </Core>
        );
    }
}
